import { Timestamp } from "@bufbuild/protobuf";

import { DateTime } from "luxon";

export const convertTimestampToDate = (t: Timestamp) => {
  const seconds = Number(t.seconds);
  return new Date(seconds * 1000);
};

export const convertToTimestamp = (d: Date) => {
  const t = new Timestamp();
  t.seconds = BigInt(Math.floor(d.getTime() / 1000));
  t.nanos = 0;
  return t;
};

export const formatDateTimeDisplay = (date: Date) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedDate = DateTime.fromJSDate(date)
    .setZone(timezone)
    .toFormat("dd MMM yyyy hh:mm a ZZZZ");
  return formattedDate;
};

/**
 * The date alone when the time carries nothing, the full timestamp when it
 * does. Billing terms and periods land on midnight, so "30 Jun 2026 12:00 AM
 * GMT+10" is 28 characters saying "30 Jun 2026" - and two of them together
 * wrapped onto a second line for no information at all.
 */
export const formatDateDisplayOmittingMidnight = (date: Date) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zoned = DateTime.fromJSDate(date).setZone(timezone);
  return zoned.hour === 0 && zoned.minute === 0
    ? zoned.toFormat("dd MMM yyyy")
    : formatDateTimeDisplay(date);
};

// Returns a Promise that resolves after "ms" Milliseconds
export const timeDelay = (ms: number) =>
  new Promise((res) => setTimeout(res, ms));
